<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良代号</label>
            <em class="weui-form-preview__value">{{form.main.code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.description" slot="description">
            <label class="weui-form-preview__label">{{customLabel.description || "不良现象描述"}}</label>
            <span class="weui-form-preview__value">{{form.main.description}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.defect_level" slot="defect_level">
            <label class="weui-form-preview__label">{{customLabel.defect_level || "缺陷等级"}}</label>
            <span class="weui-form-preview__value">{{form.main.defect_level}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.status" slot="status">
            <label class="weui-form-preview__label">{{customLabel.status || "状态"}}</label>
            <span class="weui-form-preview__value">{{form.main.status}}</span>
          </div>
        </custom-layout>
      </div>
    </div> 
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/qcNgCodeSet",
      caller:'QcNgCodeSet',
      // xtype:'stock-qcngset-formpanel'
    };
  }
};
</script>